import type { LocationBuilderState } from './builder';

export function getLocationContext(builderState: LocationBuilderState): string | null {
    const state = builderState?.state;
    const model = builderState?.state?.model;

    const resolvers: Record<string, string | null> = {
        'state-page': state?.state?.name ?? null,
        'metro-page': state?.metro?.name ?? null,
        'clinic-page': state?.store?.marketingCity || null,
    };

    return resolvers[model] ?? null;
}
